import { render, staticRenderFns } from "./dialog-maintenance.vue?vue&type=template&id=384bcb7e&"
import script from "./dialog-maintenance.vue?vue&type=script&lang=js&"
export * from "./dialog-maintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports